import { Card } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
// import CeoChart from "./ceoChart";
// import Card from "../../../ui/card/Card";
import Card1 from '../../../ui/card/Card1'
import analytics from '../../../dashboardicon/Analytics.svg'
import ctm from '../../../dashboardicon/ControlTableManagement.svg'
import erm from '../../../dashboardicon/E-RollManagement.svg'
import fpr from '../../../dashboardicon/FormProcessing.svg'
import pop1 from '../../../dashboardicon/Population1.svg'
import um from '../../../dashboardicon/Usermanagement.svg'
import Dashboard from '../DashBoardWithChart/Dashboard'
import { useGetElectionDetailsQuery } from '../../../services/announceElection'
import NoElection from '../../NoElection'
import { useEffect } from 'react'
import moment from 'moment'
import { useState } from 'react'
import LeftMenu from '../../AnalyticsModule/Left'
import DownloadInstruction from '../Dashboard/DownloadInstruction'

const RoDashboard = () => {
  const {data,isSuccess}=useGetElectionDetailsQuery()
  const [date,setDate]=useState("")
    

  useEffect(()=>{
   
    var startDate = moment(data?.payload?.[0]?.startDate).subtract(1,"days").format('MM/DD/YYYY HH:mm')
    setDate(startDate)

  },[data])
  return (
    <>
    <LeftMenu>
      { (isSuccess && data?.message==="Success")?<><Dashboard />
       </>:(isSuccess && data?.message!=="Success")?<NoElection data={"No Election Scheduled for your Constituency"} />:""}
      {/* <Button className="btn-class" value="Refresh" onClick={refreshchange} /> */}
      <DownloadInstruction />
      </LeftMenu>
    </>
  )
}

export default RoDashboard
